import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InnovationSubHeadingRoutingModule } from './innovation-subheading-routing.module';
import { InnovationsubheadingListComponent } from './innovationsubheading-list/innovationsubheading-list.component';
import { InnovationsubheadingCreateComponent } from './innovationsubheading-create/innovationsubheading-create.component';

@NgModule({
  declarations: [InnovationsubheadingListComponent, InnovationsubheadingCreateComponent],
  imports: [
    CommonModule,
    InnovationSubHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InnovationSubHeadingModule { }
